
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pakkereiser/[countryLevel1]",
      function () {
        return require("private-next-pages/pakkereiser/[countryLevel1].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pakkereiser/[countryLevel1]"])
      });
    }
  